<!-- UNIVAPLAT-3694: configurable link-records modal (role/aria-modal/focus trap come from NgbModal) -->
<div class="modal-header">
    <h1 class="modal-title fs-5 fw-normal" [id]="titleId" data-testid="link-records-title">{{ heading }}</h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"
            data-testid="link-records-close"></button>
</div>
<div class="modal-body">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="alert alert-warning mb-0" role="alert" data-testid="link-records-error">{{ loadError }}</div>
    } @else if (candidates.length === 0) {
        <p class="text-muted mb-0" data-testid="link-records-empty">{{ emptyMessage }}</p>
    } @else {
        <div class="table-responsive">
            <table class="table table-sm align-middle" data-testid="link-records-table">
                <caption class="visually-hidden">{{ heading }}</caption>
                <thead>
                    <tr>
                        <th scope="col"><span class="visually-hidden">Select</span></th>
                        @for (column of columns; track column.header) {
                            <th scope="col">{{ column.header }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (candidate of candidates; track candidate.id) {
                        <tr data-testid="link-records-row">
                            <td>
                                <input type="checkbox" class="form-check-input"
                                       [attr.aria-label]="rowName(candidate)"
                                       [checked]="isSelected(candidate)"
                                       [disabled]="saving"
                                       (change)="toggle(candidate, $any($event.target).checked)"
                                       data-testid="link-records-checkbox">
                            </td>
                            @for (column of columns; track column.header) {
                                <td>{{ cell(column, candidate) }}</td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-gray text-dark" (click)="modal.dismiss(false)"
            data-testid="link-records-cancel">Cancel</button>
    <button type="button" class="btn btn-success"
            [disabled]="saving || loading || selectedCount === 0"
            (click)="onSubmit()"
            data-testid="link-records-submit">
        {{ submitLabel }}
    </button>
</div>
